export default "__VITE_ASSET__BDGzuKHu__"